
<button [ngClass]="{'esk-tool--active' : active()===true}" [appTooltip]="'Draw ' + definition().drawType" class="esk-tool" (click)="active.set(!active())"><i [className]="definition().icon"></i></button>
@if (active()) {
  <button  appTooltip="Undo Last Point" class="esk-tool" (click)="undo()"><i class="fa fa-undo"></i></button>
  <ng-container
  intersectTool
  [intersectTargetLayers]="intersectTargetLayers()"
  [intersectTargetFeatures]="intersectTargetFeatures()"
  ></ng-container>
  <ng-container
  differenceTool
  [differenceTargetLayers]="differenceTargetLayers()"
  ></ng-container>
}
